import React from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { Layout, Tabs, Typography } from 'antd';
import Footer from '../../layouts/sections/Footer';
import FourOhFour from '../../pages/404';
import ManageAddresses from '../../pages/Settings/ManageAddresses';
import ManageInvoice from '../../pages/Settings/ManageInvoice';
import ManageEmails from '../../pages/Settings/ManageEmails/';
import ManageMobile from '../../pages/Settings/ManageMobile';
import TaxExemptions from '../../pages/Settings/TaxExemptions';
import NDAList from '../../pages/Settings/NDAList';
import ChangePassword from '../../pages/Settings/ChangePassword';
import CompanyProfile from '../../pages/Settings/CompanyProfile';

import { observer } from 'mobx-react';
import ManageRequirements from '../../pages/Settings/ManageRequirements';
import UserStore from '../../stores/UserStore';
import RedirectPreservingUTMQuery from '../../common/RedirectPreservingUTMQuery';

const { Content } = Layout;
const { Title } = Typography;

const SettingsRouter = () => {
    const history = useHistory();
    const location = useLocation();
    const activeKey = location.pathname.replace(/^\/my-account\/settings\/?/, '').split('/')[0];
    const items = [
        {
            label: 'Company Profile',
            key: 'company-profile',
            rules: [],
        },
        {
            label: 'Email',
            key: 'emails',
            rules: [],
        },
        { label: 'Password', key: 'password-change', rules: [] },
        { label: 'Order Requirements', key: 'order-requirements', rules: ['needs_contact'] },
        { label: 'Addresses', key: 'addresses', rules: ['needs_contact'] },
        { label: 'Tax Exemptions', key: 'tax-exemptions', rules: ['needs_account', 'needs_contact'] },
        { label: 'NDA Form', key: 'nda-form', rules: ['needs_account', 'needs_contact'] },
        { label: 'Invoices', key: 'contact', rules: ['needs_account', 'needs_contact'] },
        { label: 'SMS Notifications', key: 'mobile', rules: ['needs_contact'] },
    ];

    return (
        <React.Fragment>
            <Content data-testid="page-customer-settings" data-ready="true">
                <div className="bg-white border-bottom pt-4 mb-3">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-baseline">
                            <Title level={1}>Account Settings</Title>
                        </div>

                        <Tabs
                            data-testid="customer-settings-tabs"
                            items={items
                                .filter(i => {
                                    if (!UserStore.hasAccount) {
                                        return !i.rules.includes('needs_account');
                                    }
                                    return true;
                                })
                                .filter(i => {
                                    if (!UserStore.hasAContact) {
                                        return !i.rules.includes('needs_contact');
                                    }
                                    return true;
                                })}
                            activeKey={activeKey}
                            className="m-0 p-0"
                            size="small"
                            // type="card"
                            tabBarStyle={{ marginBottom: '-1px' }}
                            onChange={path => {
                                history.push(`/my-account/settings/${path}`);
                            }}
                        />
                    </div>
                </div>

                <div className="container">
                    <Switch>
                        {/* <Route path="/my-account/settings/" exact component={SettingsDashboard} /> */}
                        <Route path="/my-account/settings/company-profile" exact component={CompanyProfile} />
                        <Route path="/my-account/settings/emails" exact component={ManageEmails} />
                        <Route path="/my-account/settings/password-change" exact component={ChangePassword} />
                        <Route path="/my-account/settings/order-requirements" exact component={ManageRequirements} />
                        <Route path="/my-account/settings/addresses" exact component={ManageAddresses} />
                        <Route path="/my-account/settings/tax-exemptions" exact component={TaxExemptions} />
                        <Route path="/my-account/settings/nda-form" exact component={NDAList} />
                        <Route path="/my-account/settings/contact" exact component={ManageInvoice} />
                        <Route path="/my-account/settings/mobile" exact component={ManageMobile} />
                        <RedirectPreservingUTMQuery to="/my-account/settings/company-profile" />
                        <Route component={FourOhFour} />
                    </Switch>
                </div>
            </Content>
            <Footer />
        </React.Fragment>
    );
};

export default observer(SettingsRouter);
